module.exports = __webpack_public_path__ + "img/click_tab3_mobile.61fcc282.png";